import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./utils";
import type { ClauseDraftGetResponse } from "../../../../src/api/src/documents/drafts/clauses";

// eslint-disable-next-line
const clauseDraftTagType = "clauseDrafts" as const;

export const clauseDraftsApi = createApi({
  reducerPath: "clauseDraftsApi",
  baseQuery: baseQuery,
  tagTypes: [clauseDraftTagType],
  endpoints: (builder) => ({
    getClauseDrafts: builder.query<ClauseDraftGetResponse, { docId: string }>({
      query: ({ docId }) => `documents/${docId}/drafts/clauses`,
      providesTags: (result) => [
        ...(result?.map((d) => ({
          type: clauseDraftTagType,
          id: d.id,
        })) ?? []),
        { type: clauseDraftTagType, id: "LIST" },
      ],
    }),
  }),
});

export const { useGetClauseDraftsQuery } = clauseDraftsApi;
